<template>
<div class="animated fadeIn">
  <v-client-table :data="buildings" :columns="columns" :options="options" :theme="theme" id="buildingDataTable">
    <template slot="child_row" slot-scope="data">
      <floor-search :floors="data.row.floors" @selected="addRoom"></floor-search>
    </template>
  </v-client-table>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
} from 'vuex'

import FloorSearch from './FloorSearch'

export default {
  name: "BuildingSearch",
  props: {
    reservation: Object
  },
  components: {
    FloorSearch
  },
  computed: {
    buildings() {
      let items = this.$store.state.reservations.availableBuildings

      // return this.isPreferred ? _.filter(items, (item) => {
      //   let preferedBuilding = _.find(this.reservation.preferred_buildings, (prefered) => prefered.id == item.id)
      //   return preferedBuilding ? true : false
      // }) : items

      return items
    },
    ...mapState({
      availRooms: state => state.reservations.availableRooms,
    })
  },
  data() {
    return {
      isPreferred: true,
      columns: [
        'name',
        'avail_rooms',
      ],
      options: {
        headings: {
          name: 'Name',
          avail_rooms: 'Available Rooms',
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      theme: 'bootstrap4',
    }
  },
  methods: {
    addRoom(room) {
      let availableRooms = _.filter(this.availRooms, item => item.id != room.id)
      this.$store.commit('reservations/setAvailableRooms', availableRooms)
      this.$emit('selected', room)
    },
    deselectRoom(room){
      let availableRooms = _.concat(this.availRooms, room)
      if(this.reservation['building'] != null && this.reservation['building']['id'] != null){
        if(room['floor'] != null && room['floor']['building'] != null && room['floor']['building']['id']  == this.reservation['building']['id']){
          this.$store.commit('reservations/setAvailableRooms', availableRooms)

        }

      }
      else{
        this.$store.commit('reservations/setAvailableRooms', availableRooms)

      }

    },
    refresh() {
      
        if(this.reservation['building'] != null && this.reservation['building']['id'] != null){
      this.$store.dispatch('reservations/searchAvailableRooms', { arrival: this.reservation.arrival_date, departure: this.reservation.departure_date, building_id: this.reservation.building.id })

    }
    else{
      this.$store.dispatch('reservations/searchAvailableRooms', { arrival: this.reservation.arrival_date, departure: this.reservation.departure_date })

    }      
    }
  },
  created() {
    this.refresh()
  }
}
</script>
